<template>
    <section>
      <vue-headful
        :title="$t('pages.kumpor') + ' - Fernando Mata'"
      />
      <article class="post" :class="shouldBeColumn ? 'column' : ''">
        <div id="content">
          <div :class="!shouldBeColumn ? 'floating' : ''">
            <img src="/kumpor.jpg">
          </div>
          <div id="text">
          <h1>{{$t("kumpor.title")}}</h1>
          <p v-html="$t('kumpor.text')" />
          </div>
        </div>
      </article>
    </section>
</template>

<script>
export default {
  computed: {
    mq() {
      return this.$mq
    },
    shouldBeColumn() {
      return this.$mq == 'verySmall' || this.$mq == 'tiny'
    }
  }
}
</script>


<style scoped>
  #content .floating {
    float: left;
    margin-right: 1.5rem;
  }
  .column >>> img {
    display: block;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
    max-width: 90%;
  }
  .column #text {
    display: inline-block;
  }
  #text >>> a {
    font-weight: bold;
  }
</style>

